import React from "react";
import { useParams, useNavigate } from "react-router-dom";

export default function ReportsList() {
  const { category } = useParams();
  const navigate = useNavigate();

  // Sub reports for each category (exact PNG)
  const reportMap = {
    "front-office": [
      "Arrival List",
      "Departure List",
      "In-House Guest List",
      "Room Status Report",
      "Occupancy Report",
      "Reservation Report",
      "Expected Arrivals",
      "Expected Departures",
      "Cancelled Reservations",
      "No-Show Reservations",
      "Checked-Out Guests",
    ],

    management: [
      "Daily Revenue Summary",
      "Room Revenue Report",
      "Manager Flash Report",
      "Daily Sales Report",
      "Housekeeping Status",
      "Room Cleaning Report",
      "Laundry Report",
      "Night Audit Summary",
      "Reconciliation Report",
    ],

    groups: [
      "Group Summary",
      "Group Rooming List",
      "Group Revenue Report",
      "Group Pickup Report",
      "Group Booking Status",
      "Group Reservation Details",
    ],

    accounting: [
      "Payment Summary",
      "Collection Report",
      "Refund Report",
      "Pending Payments",
      "Guest Ledger",
      "City Ledger",
      "Cashier Report",
      "Folio Statement",
      "Revenue Breakdown",
      "Tax Summary Report",
    ],
  };

  const reports = reportMap[category] || [];

  return (
    <div className="container py-4">
      <h3 className="fw-bold mb-3 text-capitalize">{category.replace("-", " ")}</h3>

      <div className="card">
        <div className="card-body">
          <ul className="list-group">
            {reports.map((r, idx) => (
              <li
                key={idx}
                className="list-group-item list-group-item-action"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(`/reports/${category}/${r.toLowerCase().replace(/ /g, "_")}`)
                }
              >
                {r}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
